{
  "cycle.entite.plans_cadence": "Plans de cadences proposés et appliqués",
  "cycle.entite.sprint_review_actions": "Actions de revue de cadence",
  "journalAudit.action.dependency.declared": "Dépendance entre projets déclarée",
  "journalAudit.action.sprint.plan_applied": "Plan de cadences appliqué",
  "journalAudit.action.sprint.plan_proposed": "Plan de cadences proposé"
}
